import { Box, Grid, Tooltip } from "@material-ui/core";
import { Cancel, CheckCircle } from "@material-ui/icons";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import RxAutoComplete from "../../components/RxAutoComplete";
import RxButton from "../../components/RxButton";
import RxMaskedTextField from "../../components/RxMaskedTextField";
import RxPaper from "../../components/RxPaper";
import { RxSelectBoxItemObject } from "../../components/RxSelectBox/RxSelectBox";
import RxTextField from "../../components/RxTextField";
import RxTypography from "../../components/RxTypography";
import api from "../../config/AxiosConfig";
import { SuccessResponseDTO } from "../../constants/CommonObject";
import { addNotification } from "../../redux/slices/notification-slice";
import { store } from "../../redux/store";
import {
	getRxSelectBoxItemObjectForUserValue,
	isNullOrUndefinedOrEmpty,
} from "../../utils/CommonFunctions";
import MailApprove from "./mail-approve/MailApprove";
import { UpdaterObject, UpdaterObjectInitialValue } from "./UpdateObject";
import styles from "./UpdateUserInfoStyle.module.css";
import UpdateUserInfoValidation from "./UpdateUserInfoValidation";

const UpdateUserPage = () => {
	const history = useHistory();
	const userEmail = useSelector(
		(state: RootStateOrAny) => state.user.userInfo.email
	);
	const [defaultSelectConstantDataList, setDefaultSelectConstantDataList] =
		useState<{
			province: RxSelectBoxItemObject;
			companyType: RxSelectBoxItemObject;
			jobType: RxSelectBoxItemObject;
		}>();
	const [selectConstantDataList, setSelectConstantDataList] = useState<{
		provinces: RxSelectBoxItemObject[];
		companyTypes: RxSelectBoxItemObject[];
		jobTypes: RxSelectBoxItemObject[];
	}>({
		provinces: [],
		companyTypes: [],
		jobTypes: [],
	});

	const [showMailApprovePopup, setShowMailApprovePopup] =
		useState<boolean>(false);

	const formik = useFormik({
		initialValues: UpdaterObjectInitialValue,
		validationSchema: UpdateUserInfoValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			handleSubmit();
		},
	});

	const handleSubmit = async () => {
		await api
			.put("/1/users", {
				firstname: formik.values.firstname,
				lastname: formik.values.lastname,
				job: formik.values.job,
				title: formik.values.title,
				phone: formik.values.phone,
				gsm: formik.values.gsm,
				companyType: formik.values.companyType,
				companyName: formik.values.companyName,
				province: formik.values.province,
				district: formik.values.district,
				address: formik.values.address,
			})
			.then((data: SuccessResponseDTO) => {
				store.dispatch(
					addNotification({
						message:
							"Kullanıcı bilgileri başarılı bir şekilde güncellendi.",
						type: "success",
					})
				);
				history.push("/");
			});
	};

	const getDatasFromService = async () => {
		const userInfo: UpdaterObject = await api.get("/1/users");
		const jobTypes: RxSelectBoxItemObject[] = await api.get("/1/job-types");
		const provinces: RxSelectBoxItemObject[] = await api.get("/1/provinces");
		const companyTypes: RxSelectBoxItemObject[] = await api.get(
			"/1/company-types"
		);
		setSelectConstantDataList({
			companyTypes: companyTypes,
			provinces: provinces,
			jobTypes: jobTypes,
		});
		formik.setValues(userInfo);
		setDefaultSelectConstantDataList({
			jobType: getRxSelectBoxItemObjectForUserValue(jobTypes, userInfo.job),
			companyType: getRxSelectBoxItemObjectForUserValue(
				companyTypes,
				userInfo.companyType
			),
			province: getRxSelectBoxItemObjectForUserValue(
				provinces,
				userInfo.province
			),
		});
	};

	useEffect(() => {
		if (!isNullOrUndefinedOrEmpty(userEmail)) {
			getDatasFromService();
		}
	}, [userEmail]); // eslint-disable-line

	const openMailApprovePopup = (): void => {
		setShowMailApprovePopup(true);
	};

	return (
		<RxPaper className={styles.mainPaper}>
			<>
				{defaultSelectConstantDataList && (
					<form onSubmit={formik.handleSubmit}>
						<Box>
							<Grid container direction="row" spacing={2}>
								<Grid item xs={12} sm={12}>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}></Grid>
										<Grid item xs={12} sm={12}>
											<Grid container spacing={1}>
												<Grid item xs={12} sm={12}>
													<RxTypography
														variant="h4"
														align="center"
														label={<>Kişisel Bilgilerim</>}
													/>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12} sm={12}></Grid>
										<Grid item xs={12} sm={12}></Grid>
										<Grid item xs={11} sm={7}>
											<RxTextField
												fullwidth
												disabled
												id="alternateMail"
												name="alternateMail"
												label="İletişim E-Posta Adresiniz"
												placeholder="İletişim E-Posta Adresiniz"
												value={formik.values.alternateMail ?? ""}
											/>
										</Grid>
										<Grid
											container
											item
											xs={1}
											sm={1}
											justifyContent="center"
											alignContent="center"
										>
											{formik.values.mailApprove ? (
												<Tooltip title="Doğrulanmış e-posta.">
													<CheckCircle color="primary" />
												</Tooltip>
											) : (
												<Tooltip title="Doğrulanmamış e-posta.">
													<Cancel color="secondary" />
												</Tooltip>
											)}
										</Grid>
										<Grid item xs={12} sm={4}>
											<RxButton
												label="İLETİŞİM E-POSTA DÜZENLE"
												fullWidth
												className={styles.btnCommunicationMail}
												size="large"
												color="primary"
												variant="outlined"
												onClick={() => openMailApprovePopup()}
											/>
										</Grid>
										<Grid item xs={12} sm={12}></Grid>
										<Grid item xs={12} sm={6}>
											<RxTextField
												required
												fullwidth
												id="firstname"
												name="firstname"
												label="Adınız"
												placeholder="Adınız"
												value={formik.values.firstname ?? ""}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												error={Boolean(formik.errors.firstname)}
												helperText={formik.errors.firstname}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<RxTextField
												required
												fullwidth
												id="lastname"
												name="lastname"
												label="Soyadınız"
												placeholder="Soyadınız"
												value={formik.values.lastname ?? ""}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												error={Boolean(formik.errors.lastname)}
												helperText={formik.errors.lastname}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											{defaultSelectConstantDataList?.jobType && (
												<RxAutoComplete
													required
													name="job"
													inputLabel="Mesleğiniz"
													options={selectConstantDataList.jobTypes}
													defaultValue={
														defaultSelectConstantDataList?.jobType
													}
													handleSelectChange={(
														e: any,
														newValue: any
													) => {
														formik.setFieldValue(
															"job",
															newValue.value
														);
													}}
												/>
											)}
										</Grid>
										<Grid item xs={12} sm={6}>
											<RxTextField
												fullwidth
												id="title"
												name="title"
												label="Ünvan"
												placeholder="Ünvan"
												value={formik.values.title ?? ""}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<RxMaskedTextField
												fullwidth
												required
												alwaysShowMask
												id="phone"
												name="phone"
												mask="0(999)-999-99-99"
												label="Telefon"
												placeholder="Telefon"
												value={formik.values.phone ?? ""}
												onChange={formik.handleChange}
												error={Boolean(formik.errors.phone)}
												helperText={formik.errors.phone}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<RxMaskedTextField
												fullwidth
												alwaysShowMask
												id="gsm"
												name="gsm"
												mask="0(599)-999-99-99"
												label="Cep Telefon"
												placeholder="Cep Telefon"
												value={formik.values.gsm ?? ""}
												onChange={formik.handleChange}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											{defaultSelectConstantDataList?.companyType && (
												<RxAutoComplete
													required
													name="companyType"
													inputLabel="Kuruluş Türünüz"
													options={
														selectConstantDataList.companyTypes
													}
													defaultValue={
														defaultSelectConstantDataList?.companyType
													}
													handleSelectChange={(
														e: any,
														newValue: any
													) => {
														formik.setFieldValue(
															"companyType",
															newValue.value
														);
													}}
												/>
											)}
										</Grid>
										<Grid item xs={12} sm={6}>
											<RxTextField
												required
												fullwidth
												id="companyName"
												name="companyName"
												label="Kuruluş Adı"
												placeholder="Kuruluş Adınız"
												value={formik.values.companyName ?? ""}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												error={Boolean(formik.errors.companyName)}
												helperText={formik.errors.companyName}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											{defaultSelectConstantDataList?.province && (
												<RxAutoComplete
													required
													name="province"
													inputLabel="İliniz"
													options={
														selectConstantDataList.provinces
													}
													defaultValue={
														defaultSelectConstantDataList?.province
													}
													handleSelectChange={(
														e: any,
														newValue: any
													) => {
														formik.setFieldValue(
															"province",
															newValue.value
														);
													}}
												/>
											)}
										</Grid>
										<Grid item xs={12} sm={6}>
											<RxTextField
												fullwidth
												id="district"
												name="district"
												label="İlçe"
												placeholder="İlçeniz"
												value={formik.values.district ?? ""}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
											/>
										</Grid>

										<Grid item xs={12} sm={12}>
											<RxTextField
												fullwidth
												required
												id="address"
												name="address"
												label="Adres"
												placeholder="Adresiniz"
												onBlur={formik.handleBlur}
												onChange={formik.handleChange}
												value={formik.values.address ?? ""}
												multiline={true}
												maxRow={3}
												minRow={3}
												error={Boolean(formik.errors.address)}
												helperText={formik.errors.address}
											/>
										</Grid>
										<Grid item xs={10} sm={10}></Grid>
										<Grid item xs={12} sm={2}>
											<RxButton
												fullWidth
												variant="contained"
												color={
													formik.isValid ? "primary" : "default"
												}
												type="submit"
												label="KAYDET"
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Box>
						<MailApprove
							email={formik.values.alternateMail}
							show={showMailApprovePopup}
							onClose={() => {
								setShowMailApprovePopup(false);
							}}
							setEmail={(value: string) => {
								formik.setFieldValue("alternateMail", value);
							}}
							setValidationStatus={(value: boolean) => {
								formik.setFieldValue("mailApprove", value);
							}}
						/>
					</form>
				)}
			</>
		</RxPaper>
	);
};
export default UpdateUserPage;
